import { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

export default function AppearanceToggle() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.classList.toggle('dark', savedTheme === 'dark');
  }, []);

  const toggleTheme = (mode) => {
    setTheme(mode);
    localStorage.setItem('theme', mode);
    document.documentElement.classList.toggle('dark', mode === 'dark');
  };

  return (
    <div className="w-full max-w-md mx-auto font-poppins space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Appearance</h3>

      <div className="relative w-full h-12 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg flex items-center px-1 transition-colors duration-300 shadow-sm">
        {/* Sliding indicator */}
        <div
          className={`absolute w-[114px] h-[38px] rounded-md bg-gray-300 dark:bg-gray-700 shadow transition-transform duration-300 ${
            theme === 'dark' ? 'translate-x-full' : 'translate-x-0'
          }`}
        />

        {/* Sun (Light) */}
        <button
          onClick={() => toggleTheme('light')}
          className="z-10 w-1/2 h-full flex items-center justify-center text-gray-600 dark:text-white"
        >
          <Sun className="w-5 h-5" />
        </button>

        {/* Moon (Dark) */}
        <button
          onClick={() => toggleTheme('dark')}
          className="z-10 w-1/2 h-full flex items-center justify-center text-gray-600 dark:text-white"
        >
          <Moon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
